import React from "react";
import {connect} from "react-redux";
import {
  Show,
  TextField,
  ImageField,
  SimpleShowLayout,
  RichTextField,
  BooleanField,
  DateField,
  translate
} from "admin-on-rest";
import {viewStyle} from "./style";

const GameTipTitleBase = ({record, translate}) => {
  return (
    <span>
      {translate("resources.gametips.titleEdit")}{" "}
      {record ? `"${record.title}"` : ""}
    </span>
  );
};

const GameTipTitle = translate(GameTipTitleBase);

class GameTipShowItemBase extends React.Component {
  componentDidMount() {
    if (this.props.configuration && this.props.configuration.speltips) {
      const {history} = this.props;
      if (this.props.configuration.speltips.enabled !== true)
        history.replace(`/`);
    }
  }

  componentDidUpdate(nextProps) {
    if (this.props.configuration !== nextProps.configuration) {
      const {history} = this.props;
      if (this.props.configuration.speltips.enabled !== true)
        history.replace(`/`);
    }
  }

  render() {
    const props = {...this.props};
    return (
      <Show title={<GameTipTitle />} {...props}>
        <SimpleShowLayout {...props}>
          <ImageField source="images" src="src" title="title" />
          <TextField
            style={viewStyle.textFieldStyle}
            label="resources.gametips.fields.title"
            source="title"
          />
          <TextField
            style={viewStyle.textFieldStyle}
            label="resources.gametips.fields.author"
            source="author"
          />
          <DateField
            style={viewStyle.textFieldStyle}
            label="resources.gametips.fields.date"
            source="date"
          />
          <BooleanField
            style={viewStyle.textFieldStyle}
            elStyle={viewStyle.booleanFieldStyle}
            label="resources.gametips.fields.published"
            source="published"
          />

          <RichTextField source="content" addLabel={false} />
        </SimpleShowLayout>
      </Show>
    );
  }
}

const mapStateToProps = state => {
  return {
    configuration: state.configuration
  };
};

const GameTipShowItem = connect(mapStateToProps)(
  translate(GameTipShowItemBase)
);

export default GameTipShowItem;



// WEBPACK FOOTER //
// ./src/containers/CRM/GameTips/GameTipShowItem.js